import ProjectBrowsePodsModule from './project-browse-pods.module'

export default ProjectBrowsePodsModule
